import 'babel-polyfill';
import Vue from 'vue';
import vuelidate from 'vuelidate';
import App from './App';
import router from './router';
import i18n from '@/i18n';
import store from './store';


import styleguideWeb from 'styleguide-web';
import 'styleguide-web/dist/plugins/initialize-moment.js';
import 'styleguide-web/dist/styleguide-web.css';
import './styles/main.scss';
import 'video.js/dist/video-js.css';

//import Message from '@/components/form/message.vue';
//import Loader from '@/components/form/loader.vue';
//import PlzOrt from '@/components/plzort.vue';
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';

Vue.use(styleguideWeb);
Vue.use(vuelidate);

//Vue.component('Message', Message);
//Vue.component('Loader', Loader);
//Vue.component('mb-plzort', PlzOrt);
Vue.component('vue-typeahead-bootstrap', VueTypeaheadBootstrap);


Vue.config.productionTip = false;


new Vue({
    el: '#app',
    router,
    store,
    i18n,
    template: '<App/>',
    components: { App },
});

